<div class="width100">

    <mat-checkbox [(ngModel)]="data.currentVal">{{data.name}} was completed.</mat-checkbox>
    <p class="summary2" *ngIf="undefined != getYesterday()">{{getYesterday()}} {{getYesterdayText()}}. </p>
    <p class="summary2" *ngIf="undefined === getYesterday()">Did not log {{data.getName()}} {{getYesterdayText()}}. </p>
</div>

